module.exports = __webpack_public_path__ + "img/nomad9.9c4513c7.jpg";